// Shared shape/helpers for StaffFormPage - kept separate from the component
// so the ~30-field empty-state object and the two field-list constants (used
// to build the update-diff on save) are easy to scan without wading through
// JSX.

export const emptyAddress = { street: "", city: "", state: "", postalCode: "", country: "" };
export const emptyBank = { accountNumber: "", bankName: "", bankHolder: "", ifsc: "" };
export const emptyEmergencyContact = { name: "", relationship: "", phone: "", email: "" };

export const emptyStaffForm = {
    employeeId: "", name: "", dateOfBirth: "", gender: "", bloodGroup: "", maritalStatus: "", profilePhoto: "",
    phone: "", alternatePhone: "", email: "",
    currentAddress: { ...emptyAddress }, permanentAddress: { ...emptyAddress }, sameAsCurrent: false,
    designation: "", departmentId: "", roleId: "", hubId: "", employmentType: "", dateOfJoining: "",
    probationEndDate: "", reportingTo: "",
    aadhaarNumber: "", panNumber: "", drivingLicenseNumber: "", drivingLicenseExpiry: "",
    baseSalary: "", allowances: "", bankDetails: { ...emptyBank }, uanNumber: "", pfNumber: "", esiNumber: "",
    emergencyContact: { ...emptyEmergencyContact },
    highestEducation: "", certifications: [], languagesKnown: [],
    password: "",
};

// Fields staffUpdate (PATCH /staff/staff/:staffId) accepts - everything
// except employmentType's siblings that have their own dedicated endpoints
// (financial fields, status, role, password).
export const GENERAL_FIELDS = [
    "name", "dateOfBirth", "gender", "bloodGroup", "maritalStatus", "profilePhoto",
    "phone", "alternatePhone", "email", "currentAddress", "permanentAddress",
    "designation", "employmentType", "probationEndDate", "reportingTo",
    "emergencyContact", "highestEducation", "certifications", "languagesKnown",
    "aadhaarNumber", "panNumber", "drivingLicenseNumber", "drivingLicenseExpiry",
];

// Fields staffUpdateFinancial (PATCH /staff/staff/:staffId/financial) owns -
// a genuinely separate backend call, so edit-mode save always has to weigh
// these against the loaded record independently of GENERAL_FIELDS above.
export const FINANCIAL_FIELDS = ["baseSalary", "allowances", "bankDetails", "uanNumber", "pfNumber", "esiNumber"];

export const toDateInputValue = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toISOString().slice(0, 10);
};

export const isAddressFilled = (address) => Object.values(address || {}).some((v) => String(v || "").trim());
export const isAddressComplete = (address) => Object.values(address || {}).every((v) => String(v || "").trim());
